import { render, staticRenderFns } from "./Billedlist.vue?vue&type=template&id=de1c3eb8&"
import script from "./Billedlist.vue?vue&type=script&lang=js&"
export * from "./Billedlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports